import React from 'react';
import { Link } from 'react-router-dom';
import AppShell from '../components/AppShell';
import { Card } from '../components/ui/card';
import { Link2, Bell, Users, Shield, Activity, Clock, FileText, AlertTriangle, Database } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export default function SettingsPage() {
  const { user } = useAuth();
  const isAdmin = user?.role === 'admin';
  
  const sections = [
    { name: 'Appearance', path: '/settings/theme', icon: Activity, description: 'Customize themes and colors' },
    { name: 'Integrations', path: '/settings/integrations', icon: Link2, description: 'Connect your tools' },
    { name: 'Notifications', path: '/settings/notifications', icon: Bell, description: 'Manage your alerts' },
    { name: 'Team', path: '/settings/team', icon: Users, description: 'Manage team members' },
    { name: 'Security', path: '/settings/security', icon: Shield, description: 'Security settings' },
  ];
  
  const adminSections = [
    { name: 'Sync Schedules', path: '/settings/sync-schedules', icon: Clock, description: 'Configure automatic sync schedules' },
    { name: 'Sync Logs', path: '/settings/sync-logs', icon: FileText, description: 'View sync history and logs' },
    { name: 'Alert Thresholds', path: '/settings/alert-thresholds', icon: AlertTriangle, description: 'Configure alert sensitivity thresholds' },
    { name: 'Data Maintenance', path: '/settings/data-maintenance', icon: Database, description: 'Run data maintenance and backfill operations' },
  ];

  return (
    <AppShell>
      <div className="max-w-4xl mx-auto p-6 space-y-6" data-testid="settings-page">
        <h1 className="text-3xl font-bold text-foreground/90">Settings</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {sections.map((section) => {
            const Icon = section.icon;
            return (
              <Link key={section.path} to={section.path} data-testid={`settings-${section.name.toLowerCase()}`}>
                <Card className="p-6 hover:border-primary hover:shadow-glass transition-all duration-200 cursor-pointer">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                      <h3 className="font-semibold mb-1">{section.name}</h3>
                      <p className="text-sm text-muted-foreground">{section.description}</p>
                    </div>
                  </div>
                </Card>
              </Link>
            );
          })}
        </div>
        
        {isAdmin && (
          <>
            <div className="mt-8">
              <h2 className="text-xl font-semibold mb-4 text-foreground/90">Admin Settings</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {adminSections.map((section) => {
                const Icon = section.icon;
                return (
                  <Link key={section.path} to={section.path} data-testid={`settings-${section.name.toLowerCase()}`}>
                    <Card className="p-6 hover:border-primary hover:shadow-glass transition-all duration-200 cursor-pointer border-l-4 border-l-primary">
                      <div className="flex items-start gap-4">
                        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
                          <Icon className="h-5 w-5 text-primary" />
                        </div>
                        <div>
                          <h3 className="font-semibold mb-1">{section.name}</h3>
                          <p className="text-sm text-muted-foreground">{section.description}</p>
                        </div>
                      </div>
                    </Card>
                  </Link>
                );
              })}
            </div>
          </>
        )}
      </div>
    </AppShell>
  );
}
